var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubcaseToParent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.512455 11.5318C0.854092 11.8439 1.259 12 1.72716 12H11.9053L11.9053 8.05613L10.9864 8.9998C10.7664 9.22574 10.4054 9.23216 10.1775 9.01419C9.94664 8.79343 9.94012 8.42681 10.163 8.19798L12.1089 6.19964C12.3754 5.926 12.8177 5.93484 13.0731 6.2189L14.8527 8.19876C15.0663 8.43638 15.0451 8.80257 14.8056 9.01402C14.5691 9.22281 14.2085 9.20198 13.9976 8.96735L13.0597 7.92386V12H14.2539C14.722 12 15.1301 11.8439 15.4781 11.5318C15.826 11.2197 16 10.8497 16 10.422V2.77457C16 2.34682 15.826 1.97399 15.4781 1.65607C15.1301 1.33815 14.722 1.17919 14.2539 1.17919H7.99051L6.69988 0H1.72716C1.259 0 0.854092 0.15896 0.512455 0.476879C0.170818 0.794798 0 1.16763 0 1.59538V10.422C0 10.8497 0.170818 11.2197 0.512455 11.5318Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubcaseToParent);
export default __webpack_public_path__ + "static/media/subcase-to-parent.f21201f7064ea6303a26fa61120f9666.svg";
export { ForwardRef as ReactComponent };